/* eslint-disable */
import axios from "axios";
import {baseConfig} from "@/store/config";

export const adminModule = {
    state: () => ({

        queryEvent: {},

        errors: {},

        sendSuccess: false

    }),

    getters: {},
    mutations: {
        setElementsData(state, data) {
            state.elements = data
        },
        setError(state, data) {
            state.errors = data
        },

    },

    actions: {

        async setRaceResult({state, commit}) {
            try {
                const response = await axios.post(baseConfig.BASE_URL + 'admin/race/result/', state.queryEvent.info,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )

                if (response.data.status == 'ok') {

                    commit('setElementsData', response.data.info)
                } else {
                    commit('setError', 'что то пошло не так')
                    if (response.data.status == 'error') {
                        commit('setError', response.data.mes)
                    }
                }

            } catch (e) {
                console.log('error', e)
            }
        },

        async calcRaceResult({state, commit}) {
            try {
                const response = await axios.post(baseConfig.BASE_URL + 'admin/race/calc/', state.queryEvent,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )

                if (response.data.status == 'ok') {

                    commit('setElementsData', response.data.info)
                } else {
                    commit('setError', 'что то пошло не так')
                    if (response.data.status == 'error') {
                        commit('setError', response.data.mes)
                    }
                }

            } catch (e) {
                console.log('error', e)
            }
        },

        //////////////////////////////////////////////////////

        async setFootballResult({state, commit}) {
            try {
                const response = await axios.post(baseConfig.BASE_URL + 'admin/football/result/', state.queryEvent,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )

                if (response.data.status == 'ok') {

                    commit('setElementsData', response.data.info)
                } else {
                    commit('setError', 'что то пошло не так')
                    if (response.data.status == 'error') {
                        commit('setError', response.data.mes)
                    }
                }

            } catch (e) {
                console.log('error', e)
            }
        },

        async pullFootballResult({ state, commit }, payload) {
            try {
                const response = await axios.post(
                    baseConfig.BASE_URL + 'admin/football/pull/',
                    payload,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )

                if (response.data.status !== 'ok') {
                    commit('setError', response.data.mes || 'Не удалось вытянуть результат')
                }

                return response.data
            } catch (e) {
                console.log('error', e)
                commit('setError', e.message || 'Ошибка запроса')
                throw e
            }
        },


        async pollFootballCalcStatus({ state }, matchId) {
            const response = await axios.post(
                baseConfig.BASE_URL + 'admin/football/calc_status/',
                {
                    userToken: state.queryEvent.userToken,
                    role: state.queryEvent.role,
                    matchId,
                },
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            )

            return response.data
        },

        async fetchFootballCalcPending({ state }, payload) {
            const response = await axios.post(
                baseConfig.BASE_URL + 'admin/football/calc_pending/',
                payload,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            )

            return response.data
        },

        async calcFootballTour({ state }, payload) {
            const response = await axios.post(
                baseConfig.BASE_URL + 'admin/football/calc_tour/',
                payload,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            )

            return response.data
        },

        async pullFootballTour({ state }, payload) {
            const response = await axios.post(
                baseConfig.BASE_URL + 'admin/football/pull_tour/',
                payload,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            )

            return response.data
        },

        async importFootballTour({ state }, payload) {
            const response = await axios.post(
                baseConfig.BASE_URL + 'admin/football/import_tour/',
                payload,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            )

            return response.data
        },

        async calcFootballResult({state, commit}) {
            try {
                const response = await axios.post(baseConfig.BASE_URL + 'admin/football/calc/', state.queryEvent,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )

                if (response.data.status == 'ok') {

                    commit('setElementsData', response.data.info)
                } else {
                    commit('setError', 'что то пошло не так')
                    if (response.data.status == 'error') {
                        commit('setError', response.data.mes)
                    }
                }

                return response.data

            } catch (e) {
                console.log('error', e)
                throw e
            }
        },

        async setCs2Result({ state, commit }) {
            try {
                const response = await axios.post(baseConfig.BASE_URL + 'admin/cs2/result/', state.queryEvent, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });

                if (response.data.status === 'ok') {
                    commit('setElementsData', response.data.info);
                } else {
                    commit('setError', response.data.mes || 'что то пошло не так');
                }
            } catch (e) {
                commit('setError', e.message || 'Ошибка сохранения');
            }
        },

        async calcCs2Result({ state, commit }) {
            try {
                const response = await axios.post(baseConfig.BASE_URL + 'admin/cs2/calc/', state.queryEvent, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });

                if (response.data.status === 'ok') {
                    commit('setElementsData', response.data.info);
                } else {
                    commit('setError', response.data.mes || 'что то пошло не так');
                }

                return response.data;
            } catch (e) {
                commit('setError', e.message || 'Ошибка пересчёта');
                throw e;
            }
        },

    },

    namespaced: true

}